import React from "react";
import { useTranslation } from "react-i18next";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { useGlobalStore } from "~/store";

const BeforeEvaluation = ({ setIrModal, investInfo, info, showCommentary, completeRate }) => {
	const { t } = useTranslation();
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	return (
		<section className="c__card evaluate-card judge-card">
			<div className="content">
				<h5 className="percent">
					{Number.isInteger(completeRate)
						? completeRate
						: parseFloat(completeRate).toFixed(2)}
					<i>%</i>
				</h5>
				<p className="main">
					{t("pages.investment.InvestEvalPage.detail.Step.cardForJudge.alert02.main")}
				</p>
				<p className="sub">
					{t("pages.investment.InvestEvalPage.detail.Step.cardForJudge.alert02.sub2")}
				</p>
				<div className="btn-wrap">
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={() => setIrModal(true)}
					>
						{t("pages.investment.InvestEvalPage.detail.Step.cardForJudge.button04")}
					</button>
				</div>
			</div>
			<ul className="judge-list">
				{info.role === "admin"
					? investInfo?.Judge?.map((d) => (
							<li
								key={d.idx}
								className={d.Score.length > 0 ? "complete" : "waiting"}
								onClick={() =>
									d.Score.length === 0 ? "" : showCommentary(true, d.userIdx)
								}
							>
								<img
									src={
										d.VcUser.img ||
										(theme === "dark"
											? DarkDefaultProfileImg
											: LightDefaultProfileImg)
									}
									alt={t(
										"pages.investment.InvestEvalPage.detail.Step.cardForJudge.imageAlt"
									)}
								/>
								{/*<img src={d.VcUser.img || lightProfileImg} alt="심사역" />*/}
							</li>
					  ))
					: investInfo?.Judge?.map((d) => (
							<li
								key={d.idx}
								className={d.Score.length > 0 ? "complete" : "waiting"}
								onClick={() =>
									d.Score.length === 0
										? ""
										: d.userIdx === info.idx
										? showCommentary(true, d.userIdx)
										: ""
								}
							>
								<img
									src={
										d.VcUser.img ||
										(theme === "dark"
											? DarkDefaultProfileImg
											: LightDefaultProfileImg)
									}
									alt={t(
										"pages.investment.InvestEvalPage.detail.Step.cardForJudge.imageAlt"
									)}
								/>
								{/*<img src={d.VcUser.img || lightProfileImg} alt="심사역" />*/}
							</li>
					  ))}
			</ul>
		</section>
	);
};

export default BeforeEvaluation;
